<!-- 消息提醒 -->
<template>
  <div class="zlr-remind"
       @click.stop>
    <div class="zlr-remind-icon"
         @click="isShow = !isShow">
      <img :src="unread.list.length?msgRed:msg"
           alt="">
    </div>
    <div class="zlr-remind-con"
         v-show="isShow">
      <div class="zlr-remind-menu">
        <span @click="unreadHandle"
              :class="[type==='unread'? 'active': '']">Unread （{{unread.list.length}}）</span>
        <span @click="readHandle"
              :class="[type==='read'? 'active': '']">Read （{{read.list.length}}）</span>
      </div>
      <div class="zlr-remind-container">
        <div class="zlr-remind-no-message"
             v-show="list.length === 0">
          No message
        </div>
        <ul v-show="list.length">
          <li v-for="(item,index) in list"
              :key="index">
            <div class="left">
              <img :src="item.source === 'MENTEE'?item.headPortrait:msp"
                   alt="">
            </div>
            <div class="right">
              <div class="title">
                {{item.source === 'MENTEE'? item.menteeName: 'MSP'}} <span>-</span>
                <remind-link :data="item"
                             @on-click="isShow=false"></remind-link>
              </div>
              <div class="intro">
                {{item.messageContent}}
              </div>
              <div class="time">
                {{item.createTime}}
              </div>
            </div>
          </li>
        </ul>
        <div class="more">
          <a @click="moreHandle">More+</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getMessageHome } from '@/api/message'
// less
import './remind.less'
// svg
import msg from '@/assets/images/home/msg.svg'
import msgRed from '@/assets/images/home/msg-red.svg'
import msp from '@/assets/msp.svg'
// components
import RemindLink from './remind-link'
export default {
  name: 'zlr-remind',
  components: {
    RemindLink
  },
  data () {
    return {
      msg,
      msgRed,
      msp,
      isShow: false,
      type: 'unread',
      unread: {
        total: 0,
        list: []
      },
      read: {
        total: 0,
        list: []
      },
      list: [],
      pollName: ''
    }
  },
  computed: {},
  mounted () {
    this.getList()
    this.polling()
    let self = this
    document.body.addEventListener('click', function () {
      self.isShow = false
    })
  },
  methods: {
    // 未读
    unreadHandle () {
      this.type = 'unread'
      this.list = this.unread.list
    },
    // 已读
    readHandle () {
      this.type = 'read'
      this.list = this.read.list
    },
    // 请求数据
    getList () {
      getMessageHome({
        pageSize: 5
      }).then(res => {
        this.unread = {
          list: res.data.unReadList,
          total: res.data.unReadCount
        }
        this.read = {
          list: res.data.readList,
          total: res.data.readCount
        }
        if (this.type === 'unread') {
          this.list = res.data.unReadList
        } else {
          this.list = res.data.readList
        }
      })
    },
    // 查看更多
    moreHandle () {
      this.isShow = false
      this.$router.push({
        name: 'personal-message'
      })
    },
    // 轮循
    polling () {
      setInterval(() => {
        this.getList()
      }, 60000)
    }
  },
  watch: {
    isShow (newValue) {
      if (newValue) {
        this.unreadHandle()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.pollName)
  }
}
</script>
<style lang='less' scoped>
</style>
